import { handleError } from './error';

/**
 * Get the name of the source by removing the protocol and the query string.
 * This is used to identify the tracker.
 */
export function getName(src: string) {
  /* Remove 'http://' or 'https://' */
  const noProtocol = src.replace(/^https?:\/\//, '');

  /* Remove the query string and hash */
  const noQueryOrHash = noProtocol.split(/[?&#]/)[0];

  return noQueryOrHash;
}

/**
 * Get the source of a node. If the node does not have a src attribute, check
 * the innerHTML of the node for a src attribute. If a src attribute is found,
 * return the value of the src attribute. If no src attribute is found, log an
 * error and return false.
 */
export function getInlineNodeSource(node: HTMLElement) {
  /* Typically happens with function calls to create a script tag. Regex to find the src */
  const html = node.innerHTML;
  const httpMatch = html.match(/['"]https?:\/\/[^'"]+['"]/);
  if (!httpMatch) {
    handleError({ message: `Node src could not be found. ${html}` }, 'info');

    return false;
  }
  const [found] = httpMatch;

  /* Remove quotes and whitespace */
  const src = found.replace(/['"\s+]/g, '');

  return src;
}

/** Check if a hostname matches any domain in the domainsSet */
export function isDomainMatch(hostname: string, domainsSet: Set<string>) {
  if (!domainsSet?.size) {
    return false;
  }

  return (
    domainsSet.has(hostname) ||
    [...domainsSet].some((domain) => hostname.endsWith(`.${domain}`))
  );
}
